import api from "./configuration";
import apiUrl from "./url";

const USE_AUTH_INTERCEPTOR = true;

export const ProspectAPI = {
	playersList: async () => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Prospects/Players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	createPlayer: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Prospects/Players",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	getPlayerNotes: async (playerId) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Prospects/Players/" + playerId + "/MatchesNotes",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	teamsList: async () => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Prospects/Teams",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	getByIdTeam: async (id) => {
		const response = await api.request({
			method: "GET",
			url: apiUrl + "/Prospects/Teams/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
	createTeam: async (data) => {
		const response = await api.request({
			method: "POST",
			url: apiUrl + "/Prospects/Teams",
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	updateTeam: async (id, data) => {
		const response = await api.request({
			method: "PUT",
			url: apiUrl + "/Prospects/Teams/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
			data,
		});

		return response.data;
	},
	deleteTeam: async (id) => {
		const response = await api.request({
			method: "DELETE",
			url: apiUrl + "/Prospects/Teams/" + id,
			useAuthInterceptor: USE_AUTH_INTERCEPTOR,
		});

		return response.data;
	},
};
